/**
 * Franja para reimprimir una mesa ya impresa
 */

import { useState } from 'react';
import { Printer } from 'lucide-react';
import type { DeskOrder } from '@/services/deskService';
import { QuantityStepper } from './QuantityStepper';
import { orderTime, tableName } from './orderDisplay';

interface ReprintBarProps {
  order: DeskOrder;
  isPrinting: boolean;
  onPrint: (copies: number) => void;
  onCancel: () => void;
}

export function ReprintBar({ order, isPrinting, onPrint, onCancel }: ReprintBarProps) {
  const [copies, setCopies] = useState(1);

  return (
    <div className="flex flex-wrap items-center gap-3 rounded border border-gray-200 bg-white p-3">
      <p className="mr-auto text-base font-medium text-content-primary">
        Reimprimir {tableName(order)} · {orderTime(order)}
      </p>
      <QuantityStepper value={copies} onChange={setCopies} />
      <button
        type="button"
        onClick={() => onPrint(copies)}
        disabled={isPrinting}
        className="flex h-11 items-center gap-2 rounded-md bg-content-primary px-4 text-sm font-medium text-white hover:bg-black disabled:opacity-60"
      >
        <Printer className="h-4 w-4" />
        {isPrinting ? 'Imprimiendo…' : 'Reimprimir'}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="h-11 rounded-md border border-gray-200 bg-white px-4 text-sm font-light hover:bg-gray-100"
      >
        Cancelar
      </button>
    </div>
  );
}
